import { stringify } from 'query-string';
import { isObjectEmpty } from '../../../utils';
import { PB_QUERY_CONST, AZ_QUERY_CONST, PAGINATION_QUERY_CONST } from '../../../constants';

const buildNewQuery = (query, name, key) => {
  if (!key) {
    const blankQuery = {
      ...query
    };
    if (blankQuery[`${PB_QUERY_CONST}[${name}]${AZ_QUERY_CONST}`])
      delete blankQuery[`${PB_QUERY_CONST}[${name}]${AZ_QUERY_CONST}`];
    if (blankQuery[`${PB_QUERY_CONST}[${name}]${PAGINATION_QUERY_CONST}`])
      delete blankQuery[`${PB_QUERY_CONST}[${name}]${PAGINATION_QUERY_CONST}`];
    if (isObjectEmpty(blankQuery)) return '';

    return blankQuery;
  }

  return {
    ...query,
    [`${PB_QUERY_CONST}[${name}]${AZ_QUERY_CONST}`]: key.toLowerCase(),
    [`${PB_QUERY_CONST}[${name}]${PAGINATION_QUERY_CONST}`]: 1
  };
};
const buildAzUrl = (query, name, key, url) => {
  const newQuery = buildNewQuery(query, name, key);
  const queryString = stringify(newQuery);

  return queryString ? `${url}?${queryString}` : url;
};

export default buildAzUrl;
